import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import FrontAbnormalReceivingOrderList from '../entities/front-abnormalreceivingorder-list'

interface FrontAbnormalReceivingOrderState extends ListState<FrontAbnormalReceivingOrderList> {

}

class AbnormalReceivingOrderMutations extends ListMutations<FrontAbnormalReceivingOrderList>{

}
class FrontAbnormalReceivingOrder extends ListModule<FrontAbnormalReceivingOrderState, any, FrontAbnormalReceivingOrderList>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<FrontAbnormalReceivingOrderList>(),
        loading: false,
    }
    actions = {
        async getAll(context: ActionContext<FrontAbnormalReceivingOrderState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/FrontOrder/GetAbnormalReceivingOrderList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<FrontAbnormalReceivingOrderList>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },

    };
    mutations = {
        setCurrentPage(state: FrontAbnormalReceivingOrderState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: FrontAbnormalReceivingOrderState, pagesize: number) {
            state.pageSize = pagesize;
        }
    }
}

const frontabnormalreceivingorder = new FrontAbnormalReceivingOrder();
export default frontabnormalreceivingorder;